import React, { useState } from 'react';
import { Modal, Form, Input, Button, message } from 'antd';
import axios from 'axios';

const { TextArea } = Input;

const ModalContacto = ({ visible, onClose }) => {
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);
    const [captcha, setCaptcha] = useState('');

    // Simple anti-bot: math captcha
    const [captchaQuestion, setCaptchaQuestion] = useState(generateCaptcha());

    function generateCaptcha() {
        const a = Math.floor(Math.random() * 10) + 1;
        const b = Math.floor(Math.random() * 10) + 1;
        return { question: `${a} + ${b}`, answer: (a + b).toString() };
    }

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            setSubmitting(true);
            // Enviar datos al servidor
            await axios.post('/public/contacto', values);
            message.success('Mensaje enviado correctamente');
            form.resetFields();
            setCaptcha('');
            setCaptchaQuestion(generateCaptcha());
            onClose();
        } catch (err) {
            // Si es error de validación, no mostrar mensaje
            if (err.errorFields) return;
            message.error('Error al enviar el mensaje');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal
            title="Contactanos"
            open={visible}
            onCancel={onClose}
            footer={null}
            destroyOnClose
        >
            <p style={{ marginBottom: 16 }}>
                Por favor completa el siguiente formulario para ponerte en contacto con nosotros. Te responderemos a la brevedad posible.
            </p>
            <Form
                form={form}
                layout="vertical"
                name="contacto"
                autoComplete="off"
                onFinish={handleOk}
            >
                <Form.Item
                    label="Nombres"
                    name="nombre"
                    rules={[
                        { required: true, message: 'Por favor ingresa tus nombres' },
                        { min: 2, message: 'Debe tener al menos 2 caracteres' },
                    ]}
                >
                    <Input maxLength={50} />
                </Form.Item>
                <Form.Item
                    label="Correo"
                    name="email"
                    rules={[
                        { required: true, message: 'Por favor ingresa tu correo' },
                        { type: 'email', message: 'Correo no válido' },
                    ]}
                >
                    <Input maxLength={50} />
                </Form.Item>
                <Form.Item
                    label="Teléfono"
                    name="telefono"
                    rules={[
                        { required: true, message: 'Por favor ingresa tu teléfono' },
                        { pattern: /^\d{7,15}$/, message: 'Teléfono no válido' },
                    ]}
                >
                    <Input maxLength={15} />
                </Form.Item>
                <Form.Item
                    label="Mensaje"
                    name="mensaje"
                    rules={[
                        { required: true, message: 'Por favor ingresa tu mensaje' },
                        { min: 10, message: 'El mensaje debe tener al menos 10 caracteres' },
                    ]}
                >
                    <TextArea rows={4} maxLength={500} />
                </Form.Item>
                
                <Form.Item>
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={submitting}
                        block
                    >
                        Enviar
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default ModalContacto;